import { useContext } from 'react';
import AppContext from 'app/AppContext';

export function useServices() {
    return useContext(AppContext).services;
}

export function useExchangeRate() {
    return useContext(AppContext).currencyFormat.exchangeRate;
}
